/**
 * roleMeta.js — Metadata de roles (labels + iconos + colores).
 * Extraído de DashboardLayout.jsx (iter.246 · Fase 8 UX Refactor).
 */
import { Crown, Shield, ChefHat, UserCheck, Calculator, Share2 } from "lucide-react";

export const ROLE_ICONS = {
  owner: Crown,
  manager: Shield,
  accountant: Calculator,
  kitchen: ChefHat,
  waiter: UserCheck,
  social_media: Share2,
};

export const ROLE_LABELS = {
  owner: "Propietario",
  manager: "Encargado",
  kitchen: "Cocina",
  waiter: "Camarero",
  accountant: "Contabilidad",
  social_media: "Social Media",
};

export const ROLE_COLORS = {
  owner:        "text-amber-700 bg-amber-500/10 dark:text-amber-400",
  manager:      "text-indigo-600 bg-indigo-500/10 dark:text-indigo-400",
  kitchen:      "text-orange-700 bg-orange-500/10 dark:text-orange-400",
  waiter:       "text-emerald-700 bg-emerald-500/10 dark:text-emerald-400",
  accountant:   "text-blue-600 bg-blue-500/10 dark:text-blue-400",
  social_media: "text-pink-600 bg-pink-500/10 dark:text-pink-400",
};
